import React from "react";
import SignupForm from "./components/SignupForm";
import LoginForm from "./components/LoginForm";

function App() {
  return (
    <div style={{ maxWidth: "400px", margin: "50px auto", fontFamily: "Arial" }}>
      <h1>CyberShield</h1>
      <SignupForm />
      <hr />
      <LoginForm />
    </div>
  );
}

export default App;
